/* eslint-disable complexity */
import PropTypes from 'prop-types'
import classnames from 'classnames'
import pluralize from 'pluralize'
import { Col, Row } from 'react-bootstrap'

import * as BLConstants from 'shared/constants'
import {
  registryChecklistPath,
  registryShopPath,
  registryViewAsGuestPath,
} from 'lib/urls'
import { InfoButton, ButtonGroup } from 'components/buttons'
import { daysUntil } from 'lib/date'

import * as consts from 'registry/constants'
import RegistryAvatar from '../registry-avatar'
import css from './registry-overview.scss'
import { SectionHeading } from '../../../components/headings'
import VisibilityStatus from '../visibility-status'
import { GuestViewOutlinedIcon } from '../../../components/icons'
import RegistrySwitcher from '../RegistrySwitcher'

const RegistryOverview = ({
  arrivalDate,
  currentShower,
  hasVisitorPassword,
  havingShower,
  isEligibleForRegistryDiscount,
  photoUrl,
  registryTitle,
  registryUrlSlug,
  searchLevel,
  setActiveModal,
  isBabyRegistry,
}) => (
  <Row className={classnames(css.registryOverview, 'mtxl mbs')}>
    <div className={classnames(css.registryAvatarContainer, 'visible-xs')}>
      <RegistryAvatar
        editable
        className={css.registryAvatar}
        url={photoUrl}
        onEdit={() => setActiveModal(consts.PERSONALIZE_YOUR_REGISTRY)}
      />
    </div>
    <Col sm={10}>
      <SectionHeading className={classnames(css.registryTitle, 'hidden-xs')}>
        {registryTitle}
      </SectionHeading>

      <div className="visible-xs">
        <RegistrySwitcher />
      </div>

      <OverviewDetails
        arrivalDate={arrivalDate}
        currentShower={currentShower}
        havingShower={havingShower}
        isEligibleForRegistryDiscount={isEligibleForRegistryDiscount}
      />
      <VisibilityStatus
        hasVisitorPassword={hasVisitorPassword}
        searchLevel={searchLevel}
        onClick={() => setActiveModal(consts.PRIVACY_SETTINGS)}
      />
    </Col>
    <Col className="prn-sm" sm={2} xs={12}>
      <InfoButton
        empty
        pill
        className={classnames(css.guestViewBtn, 'hidden-xs')}
        href={registryViewAsGuestPath(registryUrlSlug)}
        size="small"
      >
        Guest View
      </InfoButton>

      <ButtonGroup className="visible-xs mrl mll mtm">
        {isBabyRegistry && (
          <InfoButton
            empty
            pill
            href={registryChecklistPath}
            size="medium"
            style={{ width: '50%' }}
          >
            <div className="flex align-center justify-center">
              <i className={classnames(css.iconChecklist)} />
              Checklist
            </div>
          </InfoButton>
        )}

        <InfoButton
          empty
          pill
          className="visible-xs-inline-block"
          href={registryViewAsGuestPath(registryUrlSlug)}
          size="medium"
          style={{ width: '50%' }}
        >
          <div className="flex align-center justify-center">
            <GuestViewOutlinedIcon className="mrm" height="20" />
            Guest View
          </div>
        </InfoButton>
      </ButtonGroup>
    </Col>
  </Row>
)

RegistryOverview.propTypes = {
  setActiveModal: PropTypes.func.isRequired,
  arrivalDate: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
    .isRequired,
  currentShower: PropTypes.shape({
    date: PropTypes.string,
  }).isRequired,
  hasVisitorPassword: PropTypes.bool.isRequired,
  havingShower: PropTypes.bool.isRequired,
  isEligibleForRegistryDiscount: PropTypes.bool.isRequired,
  photoUrl: PropTypes.string.isRequired,
  registryTitle: PropTypes.string.isRequired,
  registryUrlSlug: PropTypes.string.isRequired,
  searchLevel: PropTypes.string.isRequired,
  isBabyRegistry: PropTypes.bool.isRequired,
}

RegistryOverview.contextTypes = {
  searchLevelOptions: PropTypes.shape({
    babylist: PropTypes.string,
    private: PropTypes.string,
    public: PropTypes.string,
  }),
}

export const OverviewDetails = ({
  arrivalDate,
  currentShower,
  havingShower,
  isEligibleForRegistryDiscount,
}) => {
  const daysUntilArrival = arrivalDate ? daysUntil(arrivalDate) : null
  const showShowerInfo = havingShower && currentShower && currentShower.date
  const daysUntilShower = showShowerInfo ? daysUntil(currentShower.date) : null
  return (
    <ul className={classnames(css.datesList, 'visible-xs')}>
      {arrivalDate && daysUntilArrival >= 1 && (
        <li className={classnames('flex center', css.datesListItem)}>
          <b>
            {`${daysUntilArrival} ${pluralize('day', daysUntilArrival)}`}
            {` to go!`}
          </b>
          &nbsp;🎉
        </li>
      )}
      {showShowerInfo && daysUntilShower >= 1 && (
        <li className={classnames(css.datesListItem, 'hidden-xs')}>
          <b>
            {`${daysUntilShower} ${pluralize(
              'day',
              daysUntilShower
            )} to shower`}
          </b>
        </li>
      )}
      {isEligibleForRegistryDiscount ? (
        <RegistryDiscountItem />
      ) : (
        <li className={classnames(css.datesListItem, 'hidden-xs')}>
          <b>You got this</b> 💪
        </li>
      )}
    </ul>
  )
}

OverviewDetails.propTypes = {
  arrivalDate: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
    .isRequired,
  currentShower: PropTypes.shape({
    date: PropTypes.string,
  }).isRequired,
  havingShower: PropTypes.bool.isRequired,
  isEligibleForRegistryDiscount: PropTypes.bool.isRequired,
}

export const RegistryDiscountItem = () => (
  <li className={classnames(css.datesListItem)}>
    <span className="h5 hidden-xs">✨</span>
    <b>
      {` Your`}
      <a href={registryShopPath}>
        {` ${BLConstants.CONFIG.store.registryDiscountPctDisplay} registry discount `}
      </a>
      is ready!
    </b>
  </li>
)

export default RegistryOverview
